import styles from './Glp1ProtocolStatCarousel.module.css';

export type Glp1ProtocolStat = {
  value: string;
  label: string;
  citation: string;
};

export const GLP1_PROTOCOL_STATS: Glp1ProtocolStat[] = [
  {
    value: '3×',
    label: 'Higher risk of early death from untreated severe sleep apnea',
    citation: 'Wisconsin Sleep Cohort · 2008',
  },
  {
    value: '~45%',
    label: 'Fewer snores per hour after modest weight loss in heavy snorers',
    citation: 'Braver et al. · CHEST, 1995',
  },
  {
    value: '10%',
    label: 'Weight loss can meaningfully reduce sleep apnea severity',
    citation: 'Wisconsin Sleep Cohort · JAMA, 2000',
  },
  {
    value: '550k+',
    label: 'RISE users screened for sleep apnea last year',
    citation: 'RISE internal data, 2025',
  },
];

const StatCard = ({stat}: {stat: Glp1ProtocolStat}) => (
  <div className={styles.statCard}>
    <span className={styles.value}>{stat.value}</span>
    <span className={styles.label}>{stat.label}</span>
    <span className={styles.citation}>{stat.citation}</span>
  </div>
);

/** Auto-scrolling horizontal carousel of 4 stat cards. Duplicates the set
 *  twice so the CSS keyframe scroll can loop seamlessly. */
export const Glp1ProtocolStatCarousel = () => {
  const doubled = [...GLP1_PROTOCOL_STATS, ...GLP1_PROTOCOL_STATS];
  return (
    <div className={styles.carouselRoot}>
      <div className={styles.fadeLeft} aria-hidden="true" />
      <div className={styles.fadeRight} aria-hidden="true" />
      <div className={styles.rail}>
        {doubled.map((stat, i) => (
          <StatCard key={`${stat.value}-${i}`} stat={stat} />
        ))}
      </div>
    </div>
  );
};

export default Glp1ProtocolStatCarousel;
